var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"logger",staticClass:"logger-container"},[_vm._l((_vm.logs),function(log){return [_c('span',{class:log.type},[_vm._v(" "+_vm._s(log.text)+" ")]),_c('br')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }